import { useMemo } from 'react';
import Modal from './Modal';
import { useTranslation } from '@/i18n';

interface ModalSuppressionProps {
  closeModal: () => void;
  type:
    | 'fournisseur'
    | 'prestation'
    | 'circuit'
    | 'user'
    | 'distributeur'
    | 'partnershipRequest'
    | 'client'
    | 'project'
    | 'estimate';
  actionOnClick: () => void;
  isMultiple?: boolean;
  shouldCloseModalAfterAction?: boolean;
}

const ModalDeletion = ({
  closeModal,
  type,
  actionOnClick,
  isMultiple = false,
  shouldCloseModalAfterAction = true,
}: ModalSuppressionProps) => {
  const { t } = useTranslation();

  const title = useMemo(() => {
    if (isMultiple) {
      switch (type) {
        case 'fournisseur':
          return t('modal.deletion.title.multiple.fournisseur');
        case 'prestation':
          return t('modal.deletion.title.multiple.prestation');
        case 'circuit':
          return t('modal.deletion.title.multiple.circuit');
        case 'user':
          return t('modal.deletion.title.multiple.user');
        case 'distributeur':
          return t('modal.deletion.title.multiple.distributeur');
        case 'partnershipRequest':
          return t('modal.deletion.title.multiple.partnershipRequest');
        case 'client':
          return t('modal.deletion.title.multiple.client');
        case 'project':
          return t('modal.deletion.title.multiple.project');
        case 'estimate':
          return t('modal.deletion.title.multiple.estimate');
      }
    }
    switch (type) {
      case 'fournisseur':
        return t('modal.deletion.title.single.fournisseur');
      case 'prestation':
        return t('modal.deletion.title.single.prestation');
      case 'circuit':
        return t('modal.deletion.title.single.circuit');
      case 'user':
        return t('modal.deletion.title.single.user');
      case 'distributeur':
        return t('modal.deletion.title.single.distributeur');
      case 'partnershipRequest':
        return t('modal.deletion.title.single.partnershipRequest');
      case 'client':
        return t('modal.deletion.title.single.client');
      case 'project':
        return t('modal.deletion.title.single.project');
      case 'estimate':
        return t('modal.deletion.title.single.estimate');
    }
  }, [isMultiple, t, type]);

  const message = useMemo(() => {
    if (isMultiple) {
      switch (type) {
        case 'fournisseur':
          return t('modal.deletion.message.multiple.fournisseur');
        case 'prestation':
          return t('modal.deletion.message.multiple.prestation');
        case 'circuit':
          return t('modal.deletion.message.multiple.circuit');
        case 'user':
          return t('modal.deletion.message.multiple.user');
        case 'distributeur':
          return t('modal.deletion.message.multiple.distributeur');
        case 'partnershipRequest':
          return t('modal.deletion.message.multiple.partnershipRequest');
        case 'client':
          return t('modal.deletion.message.multiple.client');
        case 'project':
          return t('modal.deletion.message.multiple.project');
        case 'estimate':
          return t('modal.deletion.message.multiple.estimate');
      }
    }
    switch (type) {
      case 'fournisseur':
        return t('modal.deletion.message.single.fournisseur');
      case 'prestation':
        return t('modal.deletion.message.single.prestation');
      case 'circuit':
        return t('modal.deletion.message.single.circuit');
      case 'user':
        return t('modal.deletion.message.single.user');
      case 'distributeur':
        return t('modal.deletion.message.single.distributeur');
      case 'partnershipRequest':
        return t('modal.deletion.message.single.partnershipRequest');
      case 'client':
        return t('modal.deletion.message.single.client');
      case 'project':
        return t('modal.deletion.message.single.project');
      case 'estimate':
        return t('modal.deletion.message.single.estimate');
    }
  }, [isMultiple, t, type]);

  return (
    <Modal
      closeModal={closeModal}
      title={title}
      message={message}
      actionTitle={
        // Benefits and circuits go to the trash; the rest is deleted for good.
        type === 'prestation' || type === 'circuit'
          ? t('modal.deletion.actionTitleTrash')
          : t('modal.deletion.actionTitle')
      }
      actionOnClick={actionOnClick}
      shouldCloseModalAfterAction={shouldCloseModalAfterAction}
    />
  );
};

export default ModalDeletion;
